/** "Oct 28, 2026" for a YYYY-MM-DD date, read as a calendar day (no time zone shift). */
export function formatNoteDate(date: string | null | undefined): string {
  if (!date) return '';
  const [year, month, day] = date.split('-').map(Number);
  if (!year || !month || !day) return date;
  return new Date(year, month - 1, day).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** "Oct 28, 2026, 4:12 PM" for a timestamp. */
export function formatNoteTimestamp(timestamp: string | null | undefined): string {
  if (!timestamp) return '';
  return new Date(timestamp).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
}
